import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CompraOnlineComponent } from './compra-online.component';
import { GerarPedidoComponent } from './gerar-pedido/gerar-pedido.component';
import { ListaPedidoComponent } from './consulta-pedido-recebido/lista-pedido/lista-pedido.component';
import { DetalhePedidoComponent } from './consulta-pedido-recebido/detalhe-pedido/detalhe-pedido.component';
import { CadastrarFornecedorComponent } from './consulta-pedido-recebido/detalhe-pedido/cadastrar-fornecedor/cadastrar-fornecedor.component';
import { ListaPedidoAprovadoComponent } from './consulta-pedido-aprovado/lista-pedido-aprovado/lista-pedido-aprovado.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';
import { VisualizaDadosNfComponent } from './consulta-pedido-aprovado/lista-pedido-aprovado/visualiza-dados-nf/visualiza-dados-nf.component';
import { RelacaoIndustriaComponent } from './relacao-industria/relacao-industria.component';
import { PlataformaPagamentoComponent } from './plataforma-pagamento/plataforma-pagamento.component';
import { TermoCondicaoComponent } from './termo-condicao/termo-condicao.component';

const routes: Routes = [{
  path: '',
  component: CompraOnlineComponent,
  children: [
    {
      path: 'gerar-pedido',
      component: GerarPedidoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['GERAR_PEDIDO_DE_VENDA'] }
    },
    {
      path: 'consulta-pedido-recebido',
      component: ListaPedidoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CONSULTAR_PEDIDOS_RECEBIDOS'] }
    },
    {
      path: 'consulta-pedido-aprovado',
      component: ListaPedidoAprovadoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CONSULTAR_PEDIDOS_APROVADOS'] }
    },
    {
      path: 'relacao-industria',
      component: RelacaoIndustriaComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['RELACAO_INDUSTRIA'] }
    },
    {
      path: 'plataforma-pagamento',
      component: PlataformaPagamentoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['PLATAFORMA_DE_PAGAMENTO'] }
    },
    {
      path: 'visualiza-dados-nf',
      component: VisualizaDadosNfComponent,
      //canActivate: [AuthGuardService],
      //data: { roles: ['CONSULTAR_PEDIDOS_APROVADOS'] }
    },
    {
      path: 'detalhe-pedido',
      component: DetalhePedidoComponent,

    },
    {
      path: 'cadastrar-fornecedor',
      component: CadastrarFornecedorComponent,
    },
    {
      path: 'termo-condicao',
      component: TermoCondicaoComponent,
    },


  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class CompraOnlineRoutingModule { }

export const routedComponents = [
  CompraOnlineComponent,
  GerarPedidoComponent,
  ListaPedidoComponent,
  DetalhePedidoComponent,
  CadastrarFornecedorComponent,
  ListaPedidoAprovadoComponent,
  RelacaoIndustriaComponent,
  PlataformaPagamentoComponent,
];
